import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import useLogout from '@/composables/useLogout'
import useGlobal from '@/composables/useGlobal'
import { useUserStore } from '@/stores/user'
import { logoutResource } from '@/services/auth.service'
import { isAuth } from '@/const'
import { prefixLanguage } from '@utils/urls'

import {
  PROFILE_PAGE_NAME,
} from '@/components/pages/cabinet/routes'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserBar',
  setup(__props, { expose: __expose }) {
  __expose();

const store = useUserStore()
const profile = computed(() => store.profile)
const { $t } = useGlobal()
const sidebar = ref(null)
const logoutQuestion = $t('Are you sure you want to log out?')

store.receive()

function closeSidebar() {
  sidebar.value.classList.remove('is-open')
}
function toggleSidebar() {
  sidebar.value.classList.toggle('is-open')
}



const __returned__ = { store, profile, $t, sidebar, logoutQuestion, closeSidebar, toggleSidebar, ref, computed, get useLogout() { return useLogout }, get useGlobal() { return useGlobal }, get useUserStore() { return useUserStore }, get logoutResource() { return logoutResource }, get isAuth() { return isAuth }, get prefixLanguage() { return prefixLanguage }, get PROFILE_PAGE_NAME() { return PROFILE_PAGE_NAME } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})